import React from 'react';
import ReactDOM from 'react-dom';
import 'react-notifications/dist/react-notifications.css';
import './index.css';
import './App.css';
import 'flag-icon-css/css/flag-icon.css';

import App from './App';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(<App />, document.getElementById('root'));

serviceWorker.unregister();
